<template>
  <!-- 申请退票 -->
  <div class="airDetails" v-loading="loading">
    <refund-ticket :detailData="detailData" v-if="detailData" @getData="getData"></refund-ticket>
    <div class="flex-center">
      <el-button type="primary" size="small" @click="submit" :disabled="!formData">提交</el-button>
      <el-button type="" size="small" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
// 订单查询
// const detail = require(`@/lib/data-service/flight/flight_domestic_buyer_manage_order_detail`);
const refund = require(`@/lib/data-service/flight/flight_domestic_buyer_white_order_refund`);
import refundSubmit from "@/lib/data-service/flight/newFligthApi/buyer_dom_white_refund";
import RefundTicket from "./components/refundTicket";
export default {
  data() {
    return {
      detailData: null,
      orderNo: "",
      orderStatus: "",
      orderStatusText: "",
      flightType: "1",
      passengers: [],
      dishonourType: "请选择",
      dishonourId: [],
      remark: "",
      loading: true,
      formData: null
    };
  },
  components: { RefundTicket },
  methods: {
    GetdetailData() {
      refund({ orderNo: this.orderNo })
        .then(res => {
          console.log(res);
          this.loading = false;
          this.detailData = res.refundRes;
        })
        .catch(() => {
          this.loading = false;
          this.$router.go(-1);
        });
    },
    getData(val) {
      this.formData = val;
    },
    getsegments(id, inputType) {
      inputType.inputC = !inputType.inputC;
      console.log(id, inputType);
      this.$forceUpdate();
    },
    submit() {
      let data = this.formData;
      if (!data.refundType)
        return this.$message({ type: "warning", message: "请选择退票类型" });
      if (data.passengerList.length == 0) {
        return this.$message({ type: "warning", message: "请选择航程信息" });
      }
      this.loading = true;
      refundSubmit(data)
        .then(res => {
          this.loading = false;
          if (res.code == this.SUCCESS_CODE) {
            this.$router.push({
              name: "air-ticket-admin-refund-order-list",
              params: { refresh: 1 }
            });
            this.$message({ type: "success", message: "申请成功！" });
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    getDishonour() {
      // if(this.dishonourType === '请选择') {
      //   return this.$message({
      //     message: "请选择退票类型",
      //     type: "error"
      //   });
      // }
      this.dishonourId = [];
      for (let i = 0; i < this.passengers.length; i++) {
        for (let j = 0; j < this.passengers[i].segments.length; j++) {
          if (this.passengers[i].segments[j].inputC === true) {
            this.dishonourId.push(this.passengers[i].segments[j].airlineId);
          }
        }
      }
      if (this.dishonourId.length === 0) {
        return this.$message({
          message: "请选择需要退票的乘客",
          type: "error"
        });
      }
      let lineId = this.dishonourId.join();
      let params = {
        lineId,
        orderNo: this.orderNo,
        refundType: "1",
        remark: this.remark
      };
      console.log(this.dishonourId, params);
      refund(params)
        .then(res => {
          console.log(res);
          this.$router.go(-1);
        })
        .catch(err => {
          return this.$message({
            message: err,
            type: "error"
          });
        });
    }
  },
  activated() {
    this.orderNo = this.$route.query.ordersNo;
    this.GetdetailData();
    // this.orderStatus = this.$route.query.orderStatus
    // this.orderStatusText = this.$route.query.orderStatusText
    // detail({orderNo: this.orderNo}).then( res => {
    //   console.log(res)
    //   this.detailData = res.detail
    //   this.flightType = res.detail.flightType
    //   this.passengers = res.detail.passengers
    //   for (let i = 0; i < this.passengers.length; i++) {
    //     this.passengers[i].inputC = false
    //     for (let j = 0; j < this.passengers[i].segments.length; j++) {
    //       this.passengers[i].segments[j].inputC = false
    //     }
    //   }
    //   console.log(this)
    //   this.$forceUpdate();
    // })
  }
};
</script>

<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";
.airDetails {
  width: 100%;
}
.content-info {
  border: 1px solid #ffb27f;
  h4 {
    background: #fff5ef;
    padding: 8px 25px;
    font-weight: 400;
  }
  &_text {
    display: flex;
    flex-flow: wrap;
    background: #fffcfa;
    padding: 15px 25px;
    span {
      width: 25%;
      display: block;
      padding: 6px 0;
    }
  }
}
</style>

